import EditUser from './EditUser'

export default EditUser



// WEBPACK FOOTER //
// ./src/components/Users/Edit/index.js